import ApiClient from './ApiClient';

class Flow extends ApiClient {
  constructor() {
    super('flows', { accountScoped: true });
  }
}

export default new Flow();
